import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {

    this.element.reset();
  }

  submit(event) {
    if (event.params.confirmOnDisable && !$(event.target).prop("checked") ){
      event.target.checked = true;
      event.stopPropagation();
      $("body").append(`<div class="modal" tabindex="-1" data-controller="landing-modal" id="confirm_modal">
                          <div class="modal-dialog">
                            <div class="modal-content">
                              <div class="modal-header">
                                <h5 class="modal-title">Are you sure?</h5>
                                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                              </div>
                              <div class="modal-body">
                                <p>${event.params.confirmOnDisable}</p>
                              </div>
                              <div class="modal-footer">
                                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                                <button type="button" class="btn btn-primary" data-form-utility-dismiss-param="#confirm_modal" data-form-utility-toggle-param="#${event.target.id}" data-form-utility-form-id-param="#${this.element.id}" data-action="form-utility#submitId" data-controller="form-utility">Continue</button>
                              </div>
                            </div>
                          </div>
                        </div>`);
      return false;
    }
    //   $.rails.fire(this.element, "submit");
    //  this.element.requestSubmit();
    Turbo.navigator.submitForm(this.element);
  }
}
